
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqojy_45HLiCEKh7tbDqrCj1TRuL_45YF8iMM95_i3dWMMT5UMeta } from "/codebuild/output/src3345345933/src/src/pages/faq.vue?macro=true";
import { default as menunsZmIIVTq0RxkqR_9FbnOYzW6dGJDl24a_5NpcEm2PoMeta } from "/codebuild/output/src3345345933/src/src/pages/menu.vue?macro=true";
import { default as indexNRSVHQHIfgPC_zdoA9R3tW_45pnQCOD0mBcOm_45xbzYkWYMeta } from "/codebuild/output/src3345345933/src/src/pages/index.vue?macro=true";
import { default as contactrORZ_45N4PnrhrsgfJj95EcAFuhPuoLIFBQ_bA8V6I3tIMeta } from "/codebuild/output/src3345345933/src/src/pages/contact.vue?macro=true";
import { default as tutorial_452r6MKCBHdZRA44dtPqiyk88u5rKVIRk8EE3uG_45Ju2UMeta } from "/codebuild/output/src3345345933/src/src/pages/tutorial.vue?macro=true";
import { default as agreementGcJ68qaPKjKhdj8MoGCcRpOFl4eDj6EPvAhQcw2dvvcMeta } from "/codebuild/output/src3345345933/src/src/pages/agreement.vue?macro=true";
import { default as about_45passONJeFxk63_OYTWkQJqIxn2G9_2GJ6H7jA6skqFNr_UwMeta } from "/codebuild/output/src3345345933/src/src/pages/about-pass.vue?macro=true";
import { default as index0BdYF9prvesRSIbPmHspbk2KgxcCIpeYJGTLJbUfcXUMeta } from "/codebuild/output/src3345345933/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93sLIVArF2kWJwKH6Nl_xbL5hGogN4hdkIjmfAzJc6ubYMeta } from "/codebuild/output/src3345345933/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancep8FsK0u1_45QW_q6D4_hrsQHr4xRJH7u6TacFd23_45D69UMeta } from "/codebuild/output/src3345345933/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93NTk0p_XGMxI6mBP62ojSasc3avTgE_5X_RGs4KXYpiUMeta } from "/codebuild/output/src3345345933/src/src/pages/notice/[id].vue?macro=true";
import { default as indexDUoC895nk1vE4OYsDr64lOdRASMOo_TzgphNI9lUTVkMeta } from "/codebuild/output/src3345345933/src/src/pages/coupon/index.vue?macro=true";
import { default as index1GH9jnRYpaZ8xETTUOgw33zbGm4yt5liXRsSFfGOHlUMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/index.vue?macro=true";
import { default as indexDXLnSlkl9A9XPn81vBO1EFq6KJ4ic0Gbp8swnbmDzG0Meta } from "/codebuild/output/src3345345933/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93qnL54u_45hUHavpzRrv_45_ULYGBE9eh0t6RYi21_pFlecUMeta } from "/codebuild/output/src3345345933/src/src/pages/parking/[id].vue?macro=true";
import { default as indexqkUsj7rN8uGl4wjWX3tS3q93fcIVZOEdlIdH5iIiptoMeta } from "/codebuild/output/src3345345933/src/src/pages/history/index.vue?macro=true";
import { default as indexK3tc8f6nvzk0xfs2OOA1rP8RHFZ_ifYuelxkUBlGgPYMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/index.vue?macro=true";
import { default as indexxqvRo8beS1yIC8i_45cuQbq9lAsxzIzBAsV56pOYTeJUYMeta } from "/codebuild/output/src3345345933/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexFIrK_451OaeXIJB0Qb5yb677MJjOcz08KfQOjqFRHOBooMeta } from "/codebuild/output/src3345345933/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavibwfZjYefbIswxpbFJHvZcjipzafLD0iUt5afeuQLIRUMeta } from "/codebuild/output/src3345345933/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editY2FlE_45slq3Y_452_GsbANME2MZK1vHRMj9v9i0vOuFijwMeta } from "/codebuild/output/src3345345933/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementyN51H3njcqRzMP3EQ2ev90Qm4vtSTyX7AM_459nwOLlDUMeta } from "/codebuild/output/src3345345933/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexGR6QjOz5iHLXZ8Bfhof0hBQozWhhSKcwfuSQaFtFHO0Meta } from "/codebuild/output/src3345345933/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453damHUFUutGf0zMbSPtNjhqUZxOlpQ1RSbFlYjnI_45NwOQMeta } from "/codebuild/output/src3345345933/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmYuuAvhok0v5U_458IN4xRwj_KFh39Za_45LwnsB_45qqItj4gMeta } from "/codebuild/output/src3345345933/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indext1gqwK9fljJmZOU56sB_452n_mC8T4_0TTBXDel_45KCycMMeta } from "/codebuild/output/src3345345933/src/src/pages/card/create/index.vue?macro=true";
import { default as indexWZd2y8_w3_mtw257H_45tiIoTo7pYLSusLtUUuDy1qXmcMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm_45wFsUcBjIqwpU02g04J_FuGDKgZAXcukMvgkku3MhQAMeta } from "/codebuild/output/src3345345933/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmLD07NBTpOyiDA9wSHLJRgWeqiPbx_AFOWtCjughek94Meta } from "/codebuild/output/src3345345933/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeQbL8vQ2e1sfQU2Lhengza5WBCrq1qsdRUu3aI30TFEMMeta } from "/codebuild/output/src3345345933/src/src/pages/membership/complete.vue?macro=true";
import { default as register06AXlsCNc9qrjkiMWUfgACvFt8QxpYxvDh8VkUzHuOEMeta } from "/codebuild/output/src3345345933/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93UDDHuLGjyDEvZzaad_45LIKIUJFqm11DCqb_VQoR91GNoMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm7mpFG5KOtmgE6Hdxp9B7vJF6hx9YIsvIKNf_455oC1vX8Meta } from "/codebuild/output/src3345345933/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_6OjUeT0g9TFer_45VbGlYAneaFtyxZfZo84IRiAEeiB4Meta } from "/codebuild/output/src3345345933/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexU1cknKUj81c1MkEXxOhD5AnkpxOaem6NIgmpBKh_452ugMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeL1aVfv5FOrRo2vDIYC5jyzV2A52grYAwiGwQLarCwEcMeta } from "/codebuild/output/src3345345933/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codejVnPDZu5OOTcLCuIA_45uM69lnMI25MC8RIJf_pbHR6bIMeta } from "/codebuild/output/src3345345933/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeGQvA6Tj1NqGGvHp1YU6_V66xGE3aZ2arNWrg3USs9KwMeta } from "/codebuild/output/src3345345933/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register3EsOBHM_s9xwlS_45y3X3KOfbiabf1tb_eIeQRaDGy8qEMeta } from "/codebuild/output/src3345345933/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeANHadWey3Es8ZIe2qtWlRreaEiDJeZjM_Et6aMciHMsMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexY9QbseJAJrzdixLlXLLWJdrj1ewg_45B9ghZL_45yyPbMVsMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmGo1eQgYc_45JnFgHEMUdSOFtd5GPZAqzRKVmldBE8YN_4Meta } from "/codebuild/output/src3345345933/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeNfMy_45VHXHqu1TP1eMJwh72DIOfT9gKHxWyJjUzStZL4Meta } from "/codebuild/output/src3345345933/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexlvwz83VYgRDBr_2IZCN2sP6pcvcGfOEsyBX1V1sPvb0Meta } from "/codebuild/output/src3345345933/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_939F2d_45OhuAIDFlqiblbSWkWtWX2YSk_NOqViz2zYUrQAMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completenw_45c40hhW_z08yOiVvF_45opx4_45k_nM6ZB8d4vYDX_45j1gMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasFtNe20WlUq0tJHgj0CEHe_IikPNqWy6QtzD7fvSS_45PYMeta } from "/codebuild/output/src3345345933/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleE0luyc7LlnuGsZKe_458t2IXU3lOETo9FU_45Crz5hY3PrgMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailFNtUry87DTP9LxgkVCMzSeopBLNHYkHDkB_ZYFYMyr0Meta } from "/codebuild/output/src3345345933/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmENDwQ_ZeKwVxVEu84z5PsaOXSNWaYmxZiar_McdPL7kMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent3DZ6ehAiygUR6lZIvav_457EfWlfip0l0t4byZa541y0gMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmOXTi_45hrXkBf_zu3P3mN9Fu8s9IMv3PCw_zyYlZ55GVwMeta } from "/codebuild/output/src3345345933/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateMxBemHSWRFlgeWz_45IJ1aVyrUX978WfwK_45yV_bMX0jMAMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeGkognwlpA6D2LAOjn_IvgxFhr5rsF6juDjGTErLNWQ0Meta } from "/codebuild/output/src3345345933/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeUWDD1T_bB3MVlOPxpNN6gjkKBBOIMcOdhl7z0y9_45da4Meta } from "/codebuild/output/src3345345933/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordxhpPgH4FTgR1CdGbFju_45Sa9RViSQ74A9cmulFh2V_fsMeta } from "/codebuild/output/src3345345933/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasZgvqquTJAZF_PIv7Cqnc7Q9sfRKtqCRd3iLF6pHSj_458Meta } from "/codebuild/output/src3345345933/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registervhKFnLW1T_g8P7jlRBUFMTP9A9RWkuzCIlB38DWqNaUMeta } from "/codebuild/output/src3345345933/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeC1ZWufjSEKrhZEJEKK_45ShPkoGrWDc1FmGf2PmqlEdrYMeta } from "/codebuild/output/src3345345933/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexGfh_KYjHmVGDuYwEZEW02ZY6pocdZh_45nuKB3JLnlq_oMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index4cbvANAz0h5A_5ClPvbHV_xM_45JA1vXl__45JvtjGQxI7cMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexHSYblWrZ4WCNbOfsff2Y_Sz2rHfRcI1DSqC1g6Ob6EwMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexZFLW7XDNUUSarcX0oCu_45bLX4iHzYfow5dCD5DhV5RdcMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateIxncdBMvgA94DweJHHhrp3Zpj_45bp91CqBVI3Pqi2BPgMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeNS3edE8kjO8VYLLcSSJ_45w0mFosqA9ox8u4DhejqfRLoMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmQDFLvOxxz_456And54royLo1YH9BWXjyaBhQ4KJvmH7NQMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexomPpDz_45L0JtHqvFNzVSmKKEcdvXlLVNAMdpdgnyWxs0Meta } from "/codebuild/output/src3345345933/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeuL_45EhjUFCn4ghB9nJfzP0VzVmjUNlupzfx5fsvHg4w8Meta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateS_45_45x1jnvS6AnNwtTapmlD5eb9BZ26MMLQkstShwCic8Meta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index7EvPNcVHsbZKLT8c4OXB2xwN2mOWpW4mvWw9j_21v_45kMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index4nR8y3C8lsYjfNqfMZNzj80v5pJ6g5WZpCO1RKBEQoAMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completezaXrmqUU_J1P_qv9_2kXWWZQxsrt6GL7L7cQ9BD_45SIYMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexHT7z0TfXw3UgQZHBzDDdp0hLcf7WRLtDyWcAcmIclzwMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeQQsdoCBLJ1BFtDpxLSKTAqne8wniMnxGX9DvT1GDJKQMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexe7505Sh9s8aeIgnOcbJkEoVmVPW_458Dpz921wn1q6VacMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexCnq0wEL5alB1S0j1ilNX1Mg3_45X9gfJUqJBSX6N6wBW4Meta } from "/codebuild/output/src3345345933/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexf6OT8aPEhTFfLG_45jpDnE3NP8A2jr_TX9TsfVghETLTEMeta } from "/codebuild/output/src3345345933/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateQiepTZyU7_45e4TEHI4aqW7i9vuCPNx_45zIOXqx8sGxQQEMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmWvDVd7nfTBNMy25AtonllkBNy92UwUm0zDU0MUYODXMMeta } from "/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menunsZmIIVTq0RxkqR_9FbnOYzW6dGJDl24a_5NpcEm2PoMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexNRSVHQHIfgPC_zdoA9R3tW_45pnQCOD0mBcOm_45xbzYkWYMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexDUoC895nk1vE4OYsDr64lOdRASMOo_TzgphNI9lUTVkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexqkUsj7rN8uGl4wjWX3tS3q93fcIVZOEdlIdH5iIiptoMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexxqvRo8beS1yIC8i_45cuQbq9lAsxzIzBAsV56pOYTeJUYMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexFIrK_451OaeXIJB0Qb5yb677MJjOcz08KfQOjqFRHOBooMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indext1gqwK9fljJmZOU56sB_452n_mC8T4_0TTBXDel_45KCycMMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm_45wFsUcBjIqwpU02g04J_FuGDKgZAXcukMvgkku3MhQAMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmLD07NBTpOyiDA9wSHLJRgWeqiPbx_AFOWtCjughek94Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeQbL8vQ2e1sfQU2Lhengza5WBCrq1qsdRUu3aI30TFEMMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register06AXlsCNc9qrjkiMWUfgACvFt8QxpYxvDh8VkUzHuOEMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm7mpFG5KOtmgE6Hdxp9B7vJF6hx9YIsvIKNf_455oC1vX8Meta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeL1aVfv5FOrRo2vDIYC5jyzV2A52grYAwiGwQLarCwEcMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codejVnPDZu5OOTcLCuIA_45uM69lnMI25MC8RIJf_pbHR6bIMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeGQvA6Tj1NqGGvHp1YU6_V66xGE3aZ2arNWrg3USs9KwMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register3EsOBHM_s9xwlS_45y3X3KOfbiabf1tb_eIeQRaDGy8qEMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmGo1eQgYc_45JnFgHEMUdSOFtd5GPZAqzRKVmldBE8YN_4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeNfMy_45VHXHqu1TP1eMJwh72DIOfT9gKHxWyJjUzStZL4Meta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexlvwz83VYgRDBr_2IZCN2sP6pcvcGfOEsyBX1V1sPvb0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completenw_45c40hhW_z08yOiVvF_45opx4_45k_nM6ZB8d4vYDX_45j1gMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleE0luyc7LlnuGsZKe_458t2IXU3lOETo9FU_45Crz5hY3PrgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailFNtUry87DTP9LxgkVCMzSeopBLNHYkHDkB_ZYFYMyr0Meta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmENDwQ_ZeKwVxVEu84z5PsaOXSNWaYmxZiar_McdPL7kMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent3DZ6ehAiygUR6lZIvav_457EfWlfip0l0t4byZa541y0gMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmOXTi_45hrXkBf_zu3P3mN9Fu8s9IMv3PCw_zyYlZ55GVwMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeGkognwlpA6D2LAOjn_IvgxFhr5rsF6juDjGTErLNWQ0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeUWDD1T_bB3MVlOPxpNN6gjkKBBOIMcOdhl7z0y9_45da4Meta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordxhpPgH4FTgR1CdGbFju_45Sa9RViSQ74A9cmulFh2V_fsMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registervhKFnLW1T_g8P7jlRBUFMTP9A9RWkuzCIlB38DWqNaUMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeC1ZWufjSEKrhZEJEKK_45ShPkoGrWDc1FmGf2PmqlEdrYMeta || {},
    component: () => import("/codebuild/output/src3345345933/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3345345933/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]